import AiSoftware from "pages/AimoParking/AiSoftware";
import UpdateVersion from "pages/AimoParking/AiSoftware/UpdateVersion";
import Company from "pages/AimoParking/Company";
import CompanyDetail from "pages/AimoParking/Company/CompanyDetail";
import CompanyUser from "pages/AimoParking/Company/CompanyUser";
import UpsertCompany from "pages/AimoParking/Company/UpsertCompanyForm";
import TitleTabArea from "pages/AimoParking/component/TitleTabArea";
import EdgeDevice from "pages/AimoParking/EdgeDevice";
import CreateEdgeDevice from "pages/AimoParking/EdgeDevice/CreateEdgeDevice";
import EdgeDeviceDetail from "pages/AimoParking/EdgeDevice/EdgeDeviceDetail";
import EditEdgeDevice from "pages/AimoParking/EdgeDevice/EditEdgeDevice";
import UpdateAiVersion from "pages/AimoParking/EdgeDevice/UpdateAiVersion";
import UpdateStatus from "pages/AimoParking/EdgeDevice/UpdateStatus";
import SystemNotification from "pages/AimoParking/SystemNotification";
import CreateSystemNotification from "pages/AimoParking/SystemNotification/CreateSystemNotification";
import SystemNotificationDetail from "pages/AimoParking/SystemNotification/SystemNotificationDetail";
import User from "pages/AimoParking/User";
import CreateUser from "pages/AimoParking/User/CreateUser";
import EditUser from "pages/AimoParking/User/EditUser";

const AimoParking = {
  Company,
  CompanyDetail,
  TitleTabArea,
  UpsertCompany,
  User,
  CreateUser,
  EditUser,
  SystemNotification,
  SystemNotificationDetail,
  CreateSystemNotification,
  CompanyUser,
  EdgeDevice,
  EditEdgeDevice,
  CreateEdgeDevice,
  EdgeDeviceDetail,
  EdgeDeviceUpdateAiVersion: UpdateAiVersion,
  EdgeDeviceUpdateStatus: UpdateStatus,
  AiSoftware,
  UpdateVersion,
};

export default AimoParking;
